module.exports = __webpack_public_path__ + "31757355c4c7769527a9779aa5c9662a.svg";